import { getCampaignById } from '../../apiClient';
import { useQuery } from '@tanstack/react-query';

const useGetCampaignByIdQuery = (campaignId, enabled = true) =>
    useQuery({
        queryKey: ['campaign', campaignId],
        queryFn: async () => getCampaignById(campaignId),
        throwOnError: (error) => false,
        refetchOnMount: false,
        retryOnMount: false,
        enabled: true, // enabled && Number.isInteger(Number.parseInt(campaignId)),
    });
export default useGetCampaignByIdQuery;
